import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TDR, getFormattedCutOffMargin } from 'tdr-common';
import { CheckoutGuardOutletContext } from '../../routes/CheckoutGuard';
import { Policy } from './Policy';
import DollarCircle from 'iconsax-react/dist/esm/DollarCircle';
import Clock from 'iconsax-react/dist/esm/Clock';


const PolicyItems = React.memo(function PolicyItems() {
	const { t } = useTranslation();
	const { restaurant, invoice, checkoutSession: session } = useOutletContext<CheckoutGuardOutletContext>();

	const isPaidBooking = invoice?.total > 0;
	const hasDeposit = invoice?.deposit > 0;

	let cancelCutoff = '24 hours';
	if (session?.time && restaurant) {
		const formattedCutoff = getFormattedCutOffMargin(session as Partial<TDR.Reservation>, restaurant, 'cancel');
		if (formattedCutoff) {
			cancelCutoff = formattedCutoff;
		}
	}

	return (
		<div className="p-3">
			{isPaidBooking && <>
				<Policy title={t('policies.seating_selection')} icon={<DollarCircle size={20} color="#D4D4D8" />}>
					<p>{t('policies.seating_selection_body')}</p>
				</Policy>
				<Policy icon={<Clock size={20} color="#D4D4D8" />} title={t('policies.cancellation_window')}>
					<p>
						{t('policies.cancellation_window_body', { hours: cancelCutoff })}
					</p>

				</Policy></>}
			{hasDeposit && <Policy title={t('titles.deposit')} icon={<DollarCircle size={20} color="#D4D4D8" />}>
				<p>{t('policies.deposit_body', { amount: `$${invoice?.deposit} per guest` })}</p>
			</Policy>}
		</div>
	);
});

export default PolicyItems;
